import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en/translation.json';
import hu from './locales/hu/translation.json';
import ro from './locales/ro/translation.json';
import enHelp from './locales/en/help.json';
import huHelp from './locales/hu/help.json';
import roHelp from './locales/ro/help.json';

const savedLng = localStorage.getItem('language') ?? 'en';

// cspell:words supportedLngs

i18n.use(initReactI18next).init({
    resources: {
        en: { translation: en, help: enHelp },
        ro: { translation: ro, help: roHelp },
        hu: { translation: hu, help: huHelp },
    },
    lng: savedLng,
    fallbackLng: 'en',
    supportedLngs: ['en', 'ro', 'hu'],
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
